import { getAmount, getDataField } from 'libs/common';
import { getDateTime } from 'services/types';

export const getTableParams = (t) => {
  const getFields = () => {
    const fields = [
      { name: 'created_at', sortField: 'created_at', title: t('grid.Дата и время'), width: 220, render: (val) => getDateTime(val) },
      {
        name: 'name',
        sortField: 'name',
        title: t('form.Клиент'),
      },
      {
        name: 'amount',
        sortField: 'amount',
        title: t('grid.Сумма'),
        render: (val) => getAmount(val),
      },
      {
        name: 'amount_used',
        sortField: 'amount_used',
        title: t('grid.Фактическая скидка'),
        width: 220,
        render: (val) => getAmount(val),
      },
      {
        name: 'fn',
        title: t('form.Номер ФН'),
        width: 240,
        render: (_val, _, row) => getDataField(row.data, 'fn'),
      },
    ];

    if (window.config.central) {
      fields.unshift({
        name: 'parking_id',
        title: t('grid.Парковка'),
        render: (val) => <ParkingCell parking_id={val} cmp={'span'} />,
        width: 'auto',
      });
    }

    return fields;
  };

  return { getFields };
};
